import { useEffect, useState, useRef } from "react";
import ApplicationsUI from "./ApplicationsUI";
import * as toast from "../../../Wrapper/toast/toast";
import * as apiHelper from "../../../Services/ApiHelper";
import * as stringConstants from "../../../Constants/stringConstants";
import { changeDateFormatForServer } from "../../../Utils/dateUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import * as commonServices from "../../../Services/common";

import * as storageConstants from "../../../Constants/storageConstant";
const Applications = () => {
  const [modalShow, setModalShow] = useState(false);
  const [applicationList, setApplicationList] = useState([]);
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const [searchQuery, setSearchQuery] = useState("");
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importList, setImportList] = useState();
  const [selectedRows, setSelectedRows] = useState([]);

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  const handleClose = () => {
    setModalShow(false);
    clearData();
  };

  const initialAddApplicationData = {
    name: "",
    description: "",
    action: "Add",
    id: null,
    status: "",
  };
  const [addApplicationData, setAddApplicationData] = useState(initialAddApplicationData);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    const applicationState = last_visited_page["applications"] || null;

    if (applicationState) {
      if (applicationState.dates) setDates(applicationState.dates);
      if (applicationState.searchQuery) setSearchQuery(applicationState.searchQuery);
      if (applicationState.page) setLastSelectedPage(applicationState.page);
    }
  }, []);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    last_visited_page["applications"] = {
      dates,
      searchQuery,
      page: lastSelectedPage,
    };
    commonServices.storeLocalData(storageConstants.LAST_VISITED_PAGE, last_visited_page);
  }, [dates, searchQuery, lastSelectedPage]);

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getApplicationsList(lastSelectedPage);
    }
  }, [dates]);

  const onPageChange = (page) => {
    getApplicationsList(page);
  };

  const getApplicationsList = (page = 1) => {
    const query = `?page=${page}&limit=10&start_date=${changeDateFormatForServer(dates.startDate)}&end_date=${changeDateFormatForServer(dates.endDate)}&q=${searchQuery}`;
    setLoading(true);
    setLastSelectedPage(page);
    apiHelper
      .getApplicationList(query)
      .then((response) => {
        if (response?.isSuccess && response?.code === 200) {
          setApplicationList(response?.data);
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  const clearData = () => {
    setAddApplicationData(initialAddApplicationData);
  };

  const validateData = () => {
    const { name, description } = addApplicationData;
    let validData = true;

    if (stringUtils.isNullOrEmpty(name)) {
      toast.warn(stringConstants.APPLICATION_NAME_REQUIRED);
      validData = false;
    } else if (!stringUtils.isValidName(name)) {
      toast.warn(stringConstants.APPLICATION_NAME_LENGTH);
      validData = false;
    }

    return validData;
  };

  const addApplication = () => {
    if (validateData()) {
      const { name, description } = addApplicationData;
      setButtonLoading(true);
      apiHelper
        .addApplication({ name, description })
        .then((response) => {
          setButtonLoading(false);
          if (response?.isSuccess && response?.code === 200) {
            getApplicationsList(lastSelectedPage);
            commonServices.fetchSystemData();
            toast.success(response.message);
            setModalShow(false);
            clearData();
          } else {
            toast.warn(response?.message);
          }
        })
        .catch((error) => {
          toast.warn(error);
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
  };

  const Action = (data, action = "") => {
    if (action === "edit") {
      setAddApplicationData({
        name: data.name,
        description: data.description,
        action: "Edit",
        id: data.id,
      });
      setModalShow(true);
    }
  };

  const editApplication = (id) => {
    if (validateData()) {
      const { name, description } = addApplicationData;
      setButtonLoading(true);
      apiHelper.editApplication(id, { name, description }).then((response) => {
        setButtonLoading(false);
        if (response?.isSuccess) {
          getApplicationsList(lastSelectedPage);
          commonServices.fetchSystemData();
          toast.success(response.message);
          setModalShow(false);
          clearData();
        } else {
          toast.warn(response?.message);
        }
      });
    }
  };

  const importListing = (data) => {
    if (importModal) {
      setLoading(true);
      apiHelper
        .importMaster("application", data)
        .then((response) => {
          if (response?.isSuccess) {
            setImportList(response?.data);
          }
        })
        .catch((err) => toast.warn(err))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const openImportModal = () => {
    setImportModal(true);
  };

  const exportList = () => {
    setButtonLoading(true);
    apiHelper
      .exportMaster("application", { ids: selectedRows })
      .then((response) => {
        if (response?.isSuccess) {
          toast.success(response?.message);
          getApplicationsList(lastSelectedPage);
          commonServices.fetchSystemData(setLoading);
        } else {
          toast.warn(response.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => {
        setButtonLoading(false);
        setImportModal(false);
      });
  };

  const statusHandler = (data) => {
    const updatedStatus = data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setAddApplicationData({ ...addApplicationData, status: updatedStatus });
    setButtonLoading(true);

    apiHelper.changeApplicationStatus(data.id, { status: updatedStatus }).then((response) => {
      setButtonLoading(false);
      if (response?.isSuccess) {
        getApplicationsList(lastSelectedPage);
        commonServices.fetchSystemData();
        toast.success(response.message);
        setModalShow(false);
        clearData();
      } else {
        toast.warn(response?.message);
      }
    });
  };

  return (
    <>
      <ApplicationsUI
        modalShow={modalShow}
        setModalShow={setModalShow}
        handleClose={handleClose}
        applicationList={applicationList}
        addApplicationData={addApplicationData}
        setAddApplicationData={setAddApplicationData}
        dates={dates}
        setDates={setDates}
        datePickerStartRef={datePickerStartRef}
        datePickerEndRef={datePickerEndRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        addApplication={addApplication}
        onPageChange={onPageChange}
        editApplication={editApplication}
        loading={loading}
        buttonLoading={buttonLoading}
        Action={Action}
        showConfirmModal={showConfirmModal}
        setShowConfirmModal={setShowConfirmModal}
        getApplicationsList={getApplicationsList}
        statusHandler={statusHandler}
        importListing={importListing}
        exportList={exportList}
        importModal={importModal}
        importList={importList}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        setImportModal={setImportModal}
        openImportModal={openImportModal}
      />
    </>
  );
};

export default Applications;
